import React, { useEffect, useState } from 'react'
import { HamburgerSpin } from 'react-animated-burgers'
import Vimage from '../../../assets/images/navMenu/v.png'
import pushEventDataLayer from '../../../utils/pushEventDataLayer'
import './nav-menu.scss'
import { LOCALE } from '../../../constants/activity-constants'

const hashChangeHandler = () => {
  const current = window.location.hash
  const alink = document.querySelector('#navMenu a[href="' + current + '"]')
  const liLinkActive = document.querySelector('#navMenu li.active')
  if (liLinkActive) {
    liLinkActive.classList.remove('active')
  }
  if (alink) {
    alink.parentElement.classList.add('active')
  }
}

const NavMenu = props => {
  const { isMobile, canBuy } = props

  const [isActive, setIsActive] = useState(false)
  const [activeMenu, setActiveMenu] = useState(false)

  const toggleButton = label => {
    pushEventDataLayer('Interacciones - Menú', 'yogo-yogo', 'click', label)
    if (isMobile) {
      setIsActive(prevState => !prevState)
      setActiveMenu(prevState => !prevState)
    }
  }
  console.log('canBuy', canBuy)
  useEffect(() => {
    hashChangeHandler()
    window.onhashchange = hashChangeHandler
  }, [])
  const Menu = () => {
    return (
      <nav className={`f-navMenu__container ${activeMenu && 'activeMenu'}`}>
        <section className="f-navMenu__content" id="navMenu">
          <h2 className="f-navMenu__content__title">MENÚ</h2>
          <ul className="f-navMenu__content__list">
            <li>
              <a
                href="#proDefense"
                onClick={() => toggleButton('Pro Defense-V')}
              >
                <p>Pro Defense-V</p>
              </a>
            </li>
            <li>
              <a href="#prebiotics" onClick={() => toggleButton('Prebióticos')}>
                <p>Prebióticos</p>
              </a>
            </li>
            <li>
              <a
                href="#rutine"
                onClick={() => toggleButton('Rutina de higiene')}
              >
                <p>Rutina de higiene</p>
              </a>
            </li>
            <li>
              <a href="#questions" onClick={() => toggleButton('Preguntas')}>
                <p>Preguntas</p>
              </a>
            </li>
            {canBuy && (
              <li>
                <a href="#buy" onClick={() => toggleButton('Comprar')}>
                  <p>Comprar</p>
                </a>
              </li>
            )}
          </ul>
        </section>
        <figure className="f-navMenu__image-mobile">
          <img
            className="f-navMenu__image-mobile__img"
            src={Vimage}
            alt="fondo v"
          />
        </figure>
      </nav>
    )
  }
  return (
    <>
      {isMobile ? (
        <>
          <HamburgerSpin
            buttonColor={isActive ? '#FF7870' : '#fff'}
            barColor={isActive ? '#fff' : '#FF7870'}
            className="f-hamburButtom"
            {...{ isActive, toggleButton }}
          />
          {
            //menu mobile
            Menu()
          }
        </>
      ) : (
        Menu()
      )}
    </>
  )
}

export default NavMenu
